import {
  IChannels,
  IChartAchare,
  IFixedPlatforms,
  ILinealPlatforms,
  IMobilePlatforms,
  IPipelines,
} from "./models";

export default class FeaturesState {
  fixedPlatforms: IFixedPlatforms[] = [];
  mobilePlatforms: IMobilePlatforms[] = [];
  linealPlatforms: ILinealPlatforms[] = [];
  pipelines: IPipelines[] = [];
  channels: IChannels[] = [];
  chartAchare: IChartAchare[] = [];
  selectedFixedPlatform: number = 0;
  selectedMobilePlatform: number = 0;
  platformTag: boolean = false;
}
